import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as React from 'react'
import {
    BarChartLoader,
    Button,
    DefaultLoader,
    DonutChartLoader,
    eventDispatcher,
    GaugeLoader,
    HeatmapChartLoader,
    Loading,
    Modal,
    PortalContainer,
    useToast
} from 'uxp/components'
import {
    generateFullUUID,
    hasProperty,
    hasValue,
    loadScriptFileAsync,
    replaceWithData,
    tryParseJSON
} from '../../../util'
import { IContextProvider, IWidgetPreloader } from '../../../uxp'
import { IAction, ILucyAction, IRedirectWidget } from '../action-editor/ActionEditor'
import { IWDDesignModeProps } from '../common'
import { CSSTransition } from 'react-transition-group';
import { IContextData } from '../../../hooks/useContextData'

interface IActionRenderComponentProps {
    designer: IWDDesignModeProps
    uxpContext: IContextProvider
    action: IAction
    contextData: IContextData,
    onClose: () => void,
    onReloadWidget: () => void,
    customParams?: any,
}


// clever hack? or ugly hack? 🤷‍♂ very clever hack 😁 ️
function parseObject(o: any, values: any): any {
    if (o == null) {
        return o;
    }
    if (typeof o == undefined) {
        return o;
    }
    if (o instanceof Date) {
        return o;
    }
    if (typeof o == 'boolean') {
        return o;
    }
    if (typeof o == 'number') {
        return o;
    }
    if (typeof o === 'string') {
        return replaceWithData(o, values);
    }

    if (o instanceof Array) {
        return o.map(x => parseObject(x, values));
    }

    let newObject: any = {};
    for (let k in o) {
        if (!o.hasOwnProperty(k)) {
            continue;
        }
        newObject[k] = parseObject(o[k], values);
    }
    return newObject;
}


const ActionRenderComponent: React.FC<IActionRenderComponentProps> = (props) => {

    if (props.designer && (props.designer.mode == 'preview' || props.designer.mode == 'thumbnail')) return null

    let [widget, setWidget] = React.useState<IRedirectWidget>(null)
    let [lucyAction, setLucyAction] = React.useState<ILucyAction>(null)

    let toast = useToast()

    React.useEffect(() => {
        if (props.action) {
            let { type, redirectUrl, redirectWidget, lucyAction, customEvent } = props.action

            if (type == 'open-url') {
                if (!redirectUrl) redirectUrl = { url: 'about:blank' }

                console.log(props, "Action Props")

                redirectUrl = parseObject(redirectUrl, props.contextData);
                let url = hasProperty(redirectUrl, '$.url') ? redirectUrl.url || 'about:blank' : 'about:blank'
                let target = hasProperty(redirectUrl, '$.target') ? redirectUrl.target || '_blank' : '_blank'
                window.open(url, target)
                if (props.onClose) props.onClose()
            }
            else if (type == 'open-widget') {
                if (!redirectWidget) redirectWidget = { widget: null, params: {} }
                redirectWidget = parseObject(redirectWidget, props.contextData);

                console.log('redirect widget ', redirectWidget);

                setWidget(redirectWidget)
            }
            else if (type == 'execute-action') {
                if (!lucyAction) lucyAction = { modelName: null, action: null, params: {} }
                lucyAction = parseObject(lucyAction, props.contextData);

                setLucyAction(lucyAction)
            }
            else if (type == 'trigger-custom-event' && !!customEvent && hasValue(customEvent?.eventId)) {
                eventDispatcher(`instance-${(new Date()).getTime()}`, customEvent.eventId, parseObject(customEvent.params || {}, props.contextData) )
            }
        }
        else {
            setWidget(null)
            setLucyAction(null)
        }

    }, [props])

    return <React.Fragment>

        <WidgetModal
            show={widget != null}
            onClose={() => { props.onClose() }}
            uxpContext={props.uxpContext}
            widget={widget}
        />

        <ExecuteActionModal
            show={lucyAction != null}
            onClose={() => { props.onClose() }}
            uxpContext={props.uxpContext}
            contextData={props.contextData}
            lucyAction={lucyAction}
            onReloadWidget={props.onReloadWidget}
            customParams={props.customParams}
        />

    </React.Fragment>
}


interface IWidgetInstanceProps {
    loading: boolean,
    widget: any,
    props: { [key: string]: any },
    component: any,
    layout?: {
        width: number,
        height: number
    }
}

interface IWidgetModalProps {
    uxpContext: IContextProvider,
    show: boolean,
    onClose: () => void,
    widget: IRedirectWidget
}
const WidgetModal: React.FunctionComponent<IWidgetModalProps> = (props) => {

    let toast = useToast()
    let [widget, setWidget] = React.useState<IWidgetInstanceProps>(null)
    let [loading, setLoading] = React.useState(true)
    let [styles, setStyles] = React.useState<React.CSSProperties>(null)
    let [loader, setLoader] = React.useState<IWidgetPreloader>('default')

    React.useEffect(() => {
        prepareWidget();
        // let deps = (window as any).Last;
        // if (deps?.params != props.widget?.params) {
        //     console.log('ACRRRR params',deps?.params,props.widget?.params);
        // }
        // if (deps?.widget != props.widget?.widget) {
        //     console.log('ACRRRR widget',deps?.params,props.widget?.widget);
        // }

    }, [JSON.stringify(props.widget?.params)]);

    // (window as any).Last = props.widget;
    React.useEffect(() => {
        if (!styles || !widget || !widget.widget || widget.widget.loading) setLoading(true)
        else setTimeout(() => { setLoading(false) }, 500)
    }, [widget, styles])

    async function prepareWidget() {
        try {

            let redirectWidget = props.widget
            if (!redirectWidget) redirectWidget = { widget: null, params: {} }
            let widgetInstance = hasProperty(redirectWidget, '$.widget') ? redirectWidget.widget || null : null
            let params = hasProperty(redirectWidget, '$.params') ? redirectWidget?.params || {} : {}

            let widget: IWidgetInstanceProps = {
                loading: true,
                widget: widgetInstance,
                props: {
                    uxpContext: props.uxpContext,
                    instanceId: generateFullUUID(),
                    renderInModal: true,
                    ...params,
                    params: { ...params }
                },
                component: null
            }

            if (widget?.widget && !widget?.component) {
                let { id, name, sourceUrl } = widget.widget
                console.log("__detaisl ", id, name);

                // find the widget in registerd widgets 
                let registeredWidgets = (window as any).Widgets
                let instance = registeredWidgets.find((r: any) => (r.id == id))
                if (!instance) {
                    await loadScriptFileAsync(sourceUrl)
                }
                registeredWidgets = (window as any).Widgets
                instance = registeredWidgets.find((r: any) => (r.id == id))

                if (!instance) {
                    toast.error("Unable to find the widget")
                    console.log("Widget not found even after loading the module");
                    return
                }

                setLoader(instance?.configs?.preLoader || 'default')

                widget.component = instance.widget
                widget.loading = false

                // props 
                let _props = instance?.configs?.props || []
                let defaultProps = instance?.defaultProps || {}
                let layout = instance?.configs?.layout || {}

                let uiProps: any = {}
                if (widget.widget.isTemplate) {
                    // get configs 
                    let details = await props?.uxpContext?.executeService('UXP', 'CardTemplate:DetailsById', { 'Id': widget?.widget?.templateId }, { json: true })
                    if (details) {
                        let template = tryParseJSON(details[0].Template, {})
                        if (template && template.uiProps) {
                            uiProps = template.uiProps
                        }

                        layout = template.__template__.layout
                    }
                }


                let __props: any = {}
                for (let p of _props) {
                    __props[p.name] = defaultProps[p.name] || ''
                }
                __props = { ...__props, ...widget.props }
                if (uiProps) {
                    __props.uiProps = uiProps
                }
                widget.props = __props


                // get width heigth 
                let docWidth = document.body.clientWidth * 95 / 100
                let cell = docWidth / 30
                let width = (layout?.w || 6) * cell
                let height = (layout?.h || 6) * cell

                let _styles: React.CSSProperties = { width, height }
                if (height > document.body.clientHeight) {
                    _styles.top = 0
                    _styles.transform = `translateX(-50%)`
                }
                setStyles(_styles)
                setWidget(prev => ({ ...prev, ...widget }))
            }
        }
        catch (e) {
            console.log("exception in prepare ", e);
        }
    }




    // let styles: React.CSSProperties = { width: 100, height: 100 }
    // if (widget?.layout && widget?.layout?.width) styles.width = widget.layout.width + 'px'
    // if (widget?.layout && widget?.layout?.height) {
    //     styles.height = widget.layout.height + 'px'
    //     if (widget.layout.height > document.body.clientHeight) {
    //         styles.top = 0
    //         styles.transform = `translateX(-50%)`
    //     }
    // }

    function renderloader() {
        let Component = DefaultLoader

        switch (loader) {
            case 'donut-chart':
                Component = DonutChartLoader
                break;
            case 'line-chart':
            case 'bar-chart':
                Component = BarChartLoader
                break;
            case 'heatmap-chart':
                Component = HeatmapChartLoader
                break;
            case 'gauge':
                Component = GaugeLoader
                break;
        }

        return <Component />
    }

    return <CSSTransition
        in={props.show && !!styles}
        timeout={300}
        classNames={'m-zoom-fc'}
        unmountOnExit={true}
    >
        <PortalContainer>
            <div className="wd-widget-render-modal-portal-container" >

                <div className="modal-backdrop"
                    onClick={() => props.onClose()}></div>

                <div className="close-btn" onClick={() => props.onClose()} >
                    <FontAwesomeIcon icon={['fas', 'times']} />
                </div>
                <div className="wd-widget-render-modal-container" style={styles}>
                    <div className="wd-widget-render-modal">

                        {loading && <div className='loader-container'>
                            {loader ? renderloader() : <Loading />}
                        </div>}
                        {!loading && widget?.component && <widget.component {...widget?.props || {}} />}
                    </div>
                </div>
            </div>
        </PortalContainer>
    </CSSTransition>
}



interface IExecuteActionModalProps {
    uxpContext: IContextProvider,
    show: boolean,
    onClose: () => void,
    lucyAction: ILucyAction,
    contextData: IContextData,
    customParams?: any,
    onReloadWidget: () => void
}

const ExecuteActionModal: React.FunctionComponent<IExecuteActionModalProps> = (props) => {

    let [title, setTitle] = React.useState('')
    let [message, setMessage] = React.useState<string>(null)
    let [showButton, setShowButton] = React.useState(false)
    let [buttonTitle, setButtonTitle] = React.useState('')
    let [reloadWidget, setReloadWidget] = React.useState(false)

    React.useEffect(() => {
        if (props.show) executeAction(props.lucyAction)
    }, [props.show])

    async function executeAction(lucyAction: ILucyAction, basePath?: string) {
        try {
            if (!props.lucyAction || !hasValue(props.lucyAction.modelName) || !hasValue(props.lucyAction.action)) return

            let { modelName, action, params, postExecution, dialogTitle, executionMsg } = lucyAction

            params = { ...params, ...props.customParams }


            console.log(`executing action `, modelName, action, params);


            setTitle(dialogTitle)
            setMessage(executionMsg)
            setShowButton(false)

            // need to parse params 
            props.uxpContext.executeAction(modelName, action, params, { json: true })
                .then(res => {
                    // on success
                    // get success action 
                    let { msg, goToHome, buttonTitle, action, reloadWidget } = postExecution.success

                    setMessage(msg)
                    setShowButton(true)
                    setButtonTitle(buttonTitle || 'Done')
                    setReloadWidget(reloadWidget)
                })
                .catch(e => {
                    // on error
                    // get success action 
                    let { msg, goToHome, buttonTitle, action, reloadWidget } = postExecution.error

                    setMessage(msg)
                    setShowButton(true)
                    setButtonTitle(buttonTitle || 'Close')
                    setReloadWidget(reloadWidget)
                })

        } catch (e) {
            setMessage('Exection failed!')
            setShowButton(true)
            setButtonTitle(buttonTitle || 'Close')
        }
    }

    return <Modal
        show={props.show && props.lucyAction && hasValue(props.lucyAction.modelName) && hasValue(props.lucyAction.action)}
        title={title}
        showCloseButton={false}
        backgroundDismiss={false}
        className="model-action-excution-popup"
    >
        <div className="content">
            <div className="msg">{message}</div>

            <div className="footer">
                {
                    showButton && <React.Fragment>
                        <Button title={buttonTitle} onClick={() => {
                            console.log('Button action ', reloadWidget);

                            if (reloadWidget) props.onReloadWidget();
                            props.onClose()

                        }} />
                    </React.Fragment>
                }
            </div>
        </div>
    </Modal>
}

export default ActionRenderComponent